module.exports = __webpack_public_path__ + "dist/assets/browser-chrome.690781813cda6230c1d423db4bee361a.png";